import { render } from "./App.vue?vue&type=template&id=c7b5a9c6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c7b5a9c6&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\school\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__